(() => {
  if (window.GVSPremiumFooterPolish) {
    window.GVSPremiumFooterPolish.refresh();
    return;
  }

  const FOOTER_SELECTOR = '[data-gvs-premium-footer]';
  const BAR_SELECTOR = '.compare-floating-bar';
  const DESKTOP_MEDIA = window.matchMedia('(min-width: 750px)');
  const EDGE_GAP = 16;

  let frame = 0;
  let active = false;

  function resetBar(bar) {
    if (!bar) return;
    bar.classList.remove('gvs-compare-footer-aware', 'gvs-compare-footer-hidden');
    bar.style.removeProperty('--gvs-compare-footer-offset');
  }

  function update() {
    frame = 0;

    const footer = document.querySelector(FOOTER_SELECTOR);
    const bar = document.querySelector(BAR_SELECTOR);

    if (!footer || !bar || bar.hidden || !DESKTOP_MEDIA.matches) {
      resetBar(bar);
      return;
    }

    const footerRect = footer.getBoundingClientRect();
    const barHeight = Math.max(bar.getBoundingClientRect().height, 56);
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    bar.classList.add('gvs-compare-footer-aware');

    if (footerRect.top >= viewportHeight) {
      bar.classList.remove('gvs-compare-footer-hidden');
      bar.style.setProperty('--gvs-compare-footer-offset', '0px');
      return;
    }

    if (footerRect.bottom <= 0 || footerRect.top <= barHeight + EDGE_GAP) {
      bar.classList.add('gvs-compare-footer-hidden');
      bar.style.removeProperty('--gvs-compare-footer-offset');
      return;
    }

    const visibleFooterHeight = Math.max(0, viewportHeight - footerRect.top);
    const offset = visibleFooterHeight + EDGE_GAP;

    bar.classList.remove('gvs-compare-footer-hidden');
    bar.style.setProperty('--gvs-compare-footer-offset', `${Math.round(offset)}px`);
  }

  function schedule() {
    if (!active || frame) return;
    frame = window.requestAnimationFrame(update);
  }

  function activate() {
    if (active) return;
    active = true;

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    DESKTOP_MEDIA.addEventListener?.('change', schedule);
  }

  function deactivate() {
    if (!active) return;
    active = false;

    window.removeEventListener('scroll', schedule);
    window.removeEventListener('resize', schedule);
    DESKTOP_MEDIA.removeEventListener?.('change', schedule);

    if (frame) {
      window.cancelAnimationFrame(frame);
      frame = 0;
    }

    resetBar(document.querySelector(BAR_SELECTOR));
  }

  function refresh() {
    const bar = document.querySelector(BAR_SELECTOR);
    const shouldTrack = Boolean(bar && !bar.hidden);

    if (!shouldTrack) {
      deactivate();
      return;
    }

    activate();
    schedule();
  }

  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', refresh);

  window.GVSPremiumFooterPolish = { refresh };
  refresh();
})();
